import { clsx } from 'clsx';
import { AmountUtils, ColorUtils, DateUtils } from '@shared/utils';
import { type TransactionResponse } from '@shared/api/rest/transactions';
import { Table, TableCellType } from '@shared/widgets';

const COLUMNS = ['status', 'ref', 'date', 'description', 'amount', 'original Amount', 'card'];

interface ITransactionTableProps {
  isLoading?: boolean;
  data: TransactionResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}

export const TransactionTable = (props: ITransactionTableProps) => {
  return (
    <Table
      isLoading={props.isLoading}
      isScrollable
      columns={COLUMNS}
      items={props.data.map((row) => {
        const color = ColorUtils.getTransactionStatusStyles(row.status);
        return [
          { type: TableCellType.Custom, value: <div className={clsx('py-1 px-2 text-center font-normal', color.bg, color.text)}>{color.label}</div> },
          { type: TableCellType.Text, value: row.ref },
          { type: TableCellType.Text, value: DateUtils.formatDate(row.date) },
          { type: TableCellType.Text, value: row.description },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.amountBaseCurrency, row.baseCurrency)}` },
          { type: TableCellType.Text, value: `${AmountUtils.transformToAmountWithCurrency(row.amount, row.currency)}` },
          { type: TableCellType.Text, value: row.cardNumber },
        ];
      })}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
